export const BACKGROUND_CHOICE_SET_REQUEST = 'character.BACKGROUND_CHOICE_SET_REQUEST';
export const BACKGROUND_CHOOSE = 'character.BACKGROUND_CHOOSE';
export const BACKGROUND_CUSTOM_SET_REQUEST = 'character.BACKGROUND_CUSTOM_SET_REQUEST';
export const BACKGROUND_HAS_CUSTOM_SET_REQUEST = 'character.BACKGROUND_HAS_CUSTOM_SET_REQUEST';
export const BACKGROUND_HAS_CUSTOM_SET = 'character.BACKGROUND_HAS_CUSTOM_SET';
export const BACKGROUND_HAS_CUSTOM_SET_COMMIT = 'character.BACKGROUND_HAS_CUSTOM_SET_COMMIT';
export const BACKGROUND_SET = 'character.BACKGROUND_SET';
export const BACKGROUND_SET_COMMIT = 'character.BACKGROUND_SET_COMMIT';
